export default {
    title: 'People',
    subtitle: '{n} person | {n} people',
    newPerson: 'New person',
    search: 'Search people',
    add: {
        placeholder: 'Add a person…',
        save: 'Add',
        hint: 'Enter adds — a name; fill in the rest on the right',
    },
    kinds: {
        birthday: 'Birthday',
        nameday: 'Name day',
        anniversary: 'Anniversary',
        custom: 'Custom',
    },
    kindsShort: {
        birthday: 'birthday',
        nameday: 'name day',
        anniversary: 'anniversary',
    },
    contactKinds: {
        call: 'Call',
        meeting: 'Meeting',
        message: 'Messages',
        other: 'Other',
    },
    every: {
        none: 'None',
        week: 'Weekly',
        twoWeeks: 'Every 2 weeks',
        month: 'Monthly',
        threeMonths: 'Every 3 months',
        days: 'Every {n} days',
    },
    when: {
        today: 'today',
        tomorrow: 'tomorrow',
        inDays: 'in {n} day | in {n} days',
    },
    ago: {
        today: 'today',
        yesterday: 'yesterday',
        days: '{n} day ago | {n} days ago',
        weeks: '{n} wk ago',
        months: '{n} mo ago',
        years: '{n} year ago | {n} years ago',
    },
    age: {
        birthday: 'turns {n}',
        birthdayToday: 'turns {n}',
        years: '{n} years',
    },
    badge: '{when} · {what}',
    due: 'a while',
    dueTitle: 'No contact for a while',
    list: {
        noDate: 'No dates',
    },
    groups: {
        title: 'Groups',
        all: 'Everyone',
        none: 'No group',
        add: 'New group',
        pick: 'Group',
        edit: 'Edit group “{name}”',
        name: 'Group name',
        namePlaceholder: 'e.g. Family, Work, Friends',
        color: 'Colour',
        save: 'Save',
        cancel: 'Cancel',
        remove: 'Delete',
        removed: 'Group “{name}” deleted — the people stay',
    },
    empty: {
        title: 'Nobody here yet',
        text: 'Add someone you want to remember — with birthdays, gift ideas and when you last talked.',
        noMatchTitle: 'Nobody matches',
        noMatchText: 'Change the phrase or clear the search field.',
    },
    googleBirthdays: {
        open: 'Import birthdays from Google',
        title: 'Birthdays from Google',
        intro: 'Your contacts’ birthdays from Google Calendar. The checked ones are added to people, and missing people are created.',
        loading: 'Loading birthdays from Google…',
        notConnected: 'Connect Google Calendar to import your contacts’ birthdays.',
        connect: 'Connect Google Calendar',
        loadFailed: 'Couldn’t load birthdays from Google.',
        retry: 'Try again',
        none: 'Google has no birthdays of your contacts.',
        checkAll: 'Check all',
        uncheckAll: 'Uncheck all',
        already: 'already there',
        toPerson: 'added to the person',
        newPerson: 'new person',
        add: 'Add {n} | Add {n}',
        saveFailed: 'Couldn’t save the birthdays.',
        added: 'Birthdays added: {n}',
        nothingAdded: 'All these birthdays were already there',
    },
    pick: {
        title: 'Pick a person',
        text: 'Or add a new one in the field above the list.',
    },
    person: {
        name: 'Name',
        namePlaceholder: 'Name',
        nickname: 'What you call them',
        nicknamePlaceholder: 'what you call them, e.g. mum, boss',
    },
    dates: {
        title: 'Important dates',
        add: 'Add a date',
        kind: 'Kind',
        day: 'Day',
        month: 'Month',
        year: 'Year',
        yearPlaceholder: 'year',
        label: 'Name',
        labelPlaceholder: 'e.g. Wedding, The day we met',
        save: 'Add',
        cancel: 'Cancel',
        remove: 'Delete date',
        empty: 'Birthday, name day, anniversary — they come back every year in the Planner and in “Now”.',
        leap: '29 February — on 28 February in other years',
    },
    gifts: {
        title: 'Gift ideas',
        placeholder: 'Add an idea and press Enter',
        given: 'Given ({n})',
        givenOn: 'given {date}',
        markGiven: 'Mark as given',
        unmark: 'Not given yet',
        remove: 'Delete idea',
        empty: 'When something catches your eye or you hear “I could use…”, write it down here.',
    },
    contacts: {
        title: 'Contacts',
        talkedToday: 'We talked today',
        kind: 'Kind',
        date: 'Day',
        notePlaceholder: 'About what? (optional)',
        save: 'Save',
        cancel: 'Cancel',
        remove: 'Delete contact',
        empty: 'No contact yet.',
        last: 'Last: {when}',
    },
    often: {
        title: 'How often',
        hint: 'When this much time passes since the last contact, the person shows up in “Now”.',
        due: 'It’s been a while — maybe time to get in touch?',
    },
    notes: {
        title: 'Note',
        placeholder: 'What they like, what they talked about lately, shoe size…',
    },
    toolbar: {
        back: 'Back to the list',
        remove: 'Delete person',
        saving: 'Saving…',
        saved: 'Saved',
        saveError: 'Couldn’t save — we’ll try again with the next change',
    },
    toast: {
        removed: 'Person deleted',
        undo: 'Undo',
    },
    planner: {
        birthday: '🎂 Birthday: {name}',
        nameday: '🌷 Name day: {name}',
        anniversary: '💍 Anniversary: {name}',
        custom: '📅 {label}: {name}',
        withAge: '{title} ({n})',
    },
    help: {
        add: {
            title: 'Add a person',
            text: 'Type a name and press Enter. The rest — dates, ideas, contacts — you fill in on the right.',
            more: 'The person goes to the group you’re looking at. The assistant adds people too, when you say e.g. “Kate’s birthday is 14 March”.',
        },
        groups: {
            title: 'Groups',
            text: 'Family, Work, Friends… Pick a group to see just its people.',
            more: 'A person is in at most one group — you set it on the person. Name, colour and deleting are under “…” next to the group (on a phone: tap the selected pill again). Deleting a group keeps its people.',
        },
        list: {
            title: 'Your people',
            text: 'Those whose important date is nearest are on top, then alphabetically. The badge says what and when — “in 3 days · birthday”.',
            more: 'An orange “a while” dot means more time has passed since the last contact than you set in “How often”.',
        },
        dates: {
            title: 'Important dates',
            text: 'Birthday, name day, anniversary or your own named date. They come back every year: in the Planner, and a week ahead in “Now”.',
            more: 'The year is optional — with it you see the age or which anniversary. Name days show up in “Now” only on the day.',
        },
        gifts: {
            title: 'Gift ideas',
            text: 'Write down what someone might like. Once given, tick it — the idea stays in the history under “Given”.',
            more: 'With a birthday coming, “Now” reminds you how many ideas are waiting.',
        },
        contacts: {
            title: 'Contacts',
            text: '“We talked today” saves a call, a meeting or messages, with a short note. The newest is the last contact.',
            more: 'Just tell the assistant “I talked to mum about the holidays”.',
        },
        often: {
            title: 'How often',
            text: 'Set how often you want to get in touch. When that time passes since the last contact, the person shows up in “Now”.',
            more: 'Without it, nothing reminds you.',
        },
    },
    tour: {
        welcome: {
            title: 'Welcome to People',
            description: 'A place for the people you want to remember: their birthdays, what to give them and when you last talked. Not an address book — no phones or addresses.',
        },
        person: {
            title: 'A person',
            description: 'On the right: name and what you call them (“mum”, “boss”), group, important dates, gift ideas, contacts, how often and a note. Everything saves itself.',
        },
        end: {
            title: 'That’s all',
            description: 'The guide is always under “Help” — Getting started is there too. And “What’s this?” next to a section explains it without the guide.',
        },
    },
    firstSteps: {
        person: {
            title: 'First person',
            action: 'Add a person',
            what: 'Type a name in the “Add a person…” field and press Enter.',
            why: 'Everything starts here: dates, gifts and contacts belong to a person.',
        },
        date: {
            title: 'An important date',
            action: 'Add a date',
            what: 'Open a person and add their birthday, name day or anniversary.',
            why: 'It comes back every year in the Planner, and a week ahead in “Now” — in time for a gift.',
        },
        gift: {
            title: 'A gift idea',
            action: 'Save an idea',
            what: 'Add a gift idea to a person — something they mentioned.',
            why: 'When the birthday comes, you don’t start from scratch.',
        },
        contact: {
            title: 'A contact',
            action: 'Save a talk',
            what: 'Click “We talked today” on a person and add what it was about.',
            why: 'You see when you were last in touch — and with “How often” you get a reminder when it’s been too long.',
        },
    },
};
